<ng-template #partnerLinkModalFormContent role="document" let-modal>

  <app-page-comp-header
    [showBottomBorder]="false"
    [title]="'Add Partner Link'"
  >
  </app-page-comp-header>

  <form (ngSubmit)="submitForm()" [formGroup]="partnerLinkForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body" id="partnerLinkFormDetails">

      <div class="mb-3">
        <label class="form-label" [class.required]="true">Partner company</label>
        <div class="fs-11 text-muted mb-1">Receives the feed on its own webhook.</div>
        <app-dropdown-company
          [hideLabel]="true"
          [retainFirstBlankOption]="true"
          [showSelectAllOption]="false"
          (selectOnChangeEvent)="partnerCompanyOnChange($event)"
        ></app-dropdown-company>
        @if (formSubmitted && partnerCompanyId<=0) {
          <div class="invalid-feedback d-block">A partner company is required</div>
        }
      </div>

      <div class="mb-3">
        <label class="form-label" [class.required]="true">Client company</label>
        <div class="fs-11 text-muted mb-1">Whose SIMs the partner receives. The client must hold the Location Webhook licence.</div>
        <app-dropdown-company
          [hideLabel]="true"
          [retainFirstBlankOption]="true"
          [showSelectAllOption]="false"
          (selectOnChangeEvent)="clientCompanyOnChange($event)"
        ></app-dropdown-company>
        @if (formSubmitted && clientCompanyId<=0) {
          <div class="invalid-feedback d-block">A client company is required</div>
        } @else if (formSubmitted && partnerCompanyId>0 && partnerCompanyId==clientCompanyId) {
          <div class="invalid-feedback d-block">A company cannot be its own partner</div>
        }
      </div>

      <div class="form-check form-switch form-switch-md mb-3">
        <input class="form-check-input" type="checkbox" role="switch" id="pl-include-descendants" formControlName="includeDescendants">
        <label class="form-check-label" for="pl-include-descendants">Include the client's sub companies</label>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" for="pl-ref">Partner's reference for this client</label>
          <input
            autocomplete="no-fill"
            class="form-control"
            data-lpignore="true"
            formControlName="partnerClientRef"
            id="pl-ref"
            [ngClass]="{ 'is-invalid': formSubmitted && form['partnerClientRef'].errors }"
            type="text"
          />
          <div class="fs-11 text-muted">Sent as partnerIdRef on this partner's messages.</div>
          @if (formSubmitted && form['partnerClientRef'].hasError('maxlength')) {
            <div class="invalid-feedback d-block">Maximum length of {{refMaxLength}} characters has been exceeded</div>
          }
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" for="pl-level">Agreed accuracy level</label>
          <select class="form-select" id="pl-level" formControlName="agreedAccuracyLevel">
            <option [ngValue]="null">Client's own level</option>
            @for (level of accuracyLevels; track level.id) {
              <option [ngValue]="level.id">{{ level.name }}</option>
            }
          </select>
          <div class="fs-11 text-muted">The partner gets the tighter of this and the client's level.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" for="pl-start">Start date (UTC)</label>
          <input class="form-control" type="date" id="pl-start" formControlName="startUtc" />
          <div class="fs-11 text-muted">Blank starts today. Only arrivals from this date are sent.</div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" for="pl-approved">Client approved on (UTC)</label>
          <input class="form-control" type="date" id="pl-approved" formControlName="approvedUtc" />
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" (click)="cancelForm()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn-partner-link" [disabled]="saving">{{ saving ? 'Saving...' : 'Submit' }}</button>
      </div>
    </div>

  </form>

</ng-template>
